export default __webpack_public_path__ + "fac35ca44338ffcd1b287453890339cf.svg";